import { Container } from "./styled";
import FormFeild from "./FormField";

export const Form = ({ fields, control, errors, register, values }) => {
  return (
    <Container autoComplete="off">
      {fields
        .filter((item) =>
          item.conditionalShow && values
            ? values[String(item.conditionalShow.key)] ===
              item.conditionalShow.value
            : true
        )
        .map((field, index) => (
          <FormFeild
            key={index}
            field={field}
            errors={errors}
            control={control}
            register={register}
          />
        ))}
    </Container>
  );
};
